import { useLocalSearchParams } from 'expo-router';
import { FullScreenSpinner, ScreenContainer, View } from 'smoothie';

import Statements from '../../banking/components/spaces/documents/Statements';
import { downloadFormerMemberStatement } from '../api/FormerMemberApi';
import { useFormerMemberPortal } from '../hooks/useFormerMemberPortal';

export const FormerMemberBankingStatements = () => {
    const { userId } = useLocalSearchParams<{ userId: string }>();

    const { data: portal, isLoading } = useFormerMemberPortal();
    const banking = portal?.banking.find((entry) => entry.userId === userId);

    if (isLoading) {
        return <FullScreenSpinner />;
    }

    return (
        <ScreenContainer title="Statements" hasBackButton>
            <View
                height="100%"
                $sm={{ width: 500, marginTop: 32, alignSelf: 'center' }}
            >
                <Statements
                    statements={banking?.statements ?? []}
                    userId={userId}
                    downloadStatement={downloadFormerMemberStatement}
                />
            </View>
        </ScreenContainer>
    );
};
